import BookingIconsBlackWhiteImage from 'assets/booking/booking-icons-blackwhite.png';
import BookingIconsMeetingImage from 'assets/booking/booking-icons-meeting.png';
import BookingIconsWorkplaceLunchTransportImage from 'assets/booking/booking-icons-workplace-lunch-transport.png';
import BookingIconsWorkplaceLunchImage from 'assets/booking/booking-icons-workplace-lunch.png';
import BookingIconsWorkplaceTransportImage from 'assets/booking/booking-icons-workplace-transport.png';
import BookingIconsWorkplaceImage from 'assets/booking/booking-icons-workplace.png';
import BookingIconsImage from 'assets/booking/booking-icons.png';
import { LinearGradient } from 'expo-linear-gradient';
import _ from 'lodash';
import React, { useMemo } from "react";
import isEqual from 'react-fast-compare';
import { ImageBackground, View } from 'react-native';
import { IconBackgroundStyles } from 'styles/components/atoms/IconBackground';
import { colorList } from 'utils/colors';
import { timeslotKindConstants } from 'utils/constants/timeslot-kind-constants';
import { useIsSmallDevice } from 'utils/helper-device';
import HelperPlatform from 'utils/helper-platform';
import HelperString from 'utils/helper-string';


export const IconBackgroundSizes = {
	XS: 'xs',
	S: 's',
	M: 'm',
	L: 'l',
	XL: 'xl',
}

const sizes = {
	[ IconBackgroundSizes.XS ]: 1,
	[ IconBackgroundSizes.S ]: 2,
	[ IconBackgroundSizes.M ]: 3,
	[ IconBackgroundSizes.L ]: 4,
	[ IconBackgroundSizes.XL ]: 5
};

export const IconBackground = ( { icons = [], iconSize = IconBackgroundSizes.M, iconImageStyle = null, containerStyle = {}, linearGradientStyle = {}, linearGradientColours = [ colorList.ORANGE.light, colorList.ORANGE.primary ], colourfull = false, children } ) => {

	const isSmallDevice = useIsSmallDevice();
	
	const scale = _.get( sizes, iconSize, 1 );

	const image = useMemo( () => {
		let result = BookingIconsBlackWhiteImage;
		if( colourfull ) {
			switch( true ) {
				case _.includes( icons, timeslotKindConstants.BOOKING ) && _.includes( icons, timeslotKindConstants.LUNCH ) && _.includes( icons, timeslotKindConstants.TRANSPORT ):
					result = BookingIconsWorkplaceLunchTransportImage;
					break;
				
				case _.includes( icons, timeslotKindConstants.BOOKING ) && _.includes( icons, timeslotKindConstants.LUNCH ):
					result = BookingIconsWorkplaceLunchImage;
					break;
				
				case _.includes( icons, timeslotKindConstants.BOOKING ) && _.includes( icons, timeslotKindConstants.TRANSPORT ):
					result = BookingIconsWorkplaceTransportImage;
					break;
					
				case _.includes( icons, timeslotKindConstants.MEETING_ROOM ):
					result = BookingIconsMeetingImage;
					break;
					
				case _.includes( icons, timeslotKindConstants.BOOKING ):
					result = BookingIconsWorkplaceImage;
					break;
					
				default:
					result = BookingIconsImage
			}
		}

		return result
	}, [ icons, colourfull ] )
	
	const containerStyles = [
		IconBackgroundStyles.container,
		containerStyle,
	];
	
	const imageBackgroundStyle = [
		IconBackgroundStyles.backgroundContainer,
		iconImageStyle
	]
	
	let resizeMode = 'repeat';
	const imageStyle = [
		{
			flex: 1,
			aspectRatio: 1,
			resizeMode: resizeMode,
			opacity: 0.05,
			overflow: 'hidden',
			flexWrap: 'wrap',
			...HelperPlatform.select({
				ios: {
					width: undefined,
					height: undefined,
					transform: [{
						scale: [ 'cover', 'contain' ].includes( resizeMode ) ? (isSmallDevice ? scale : ( scale / 2 )) : scale,
					}]
				},
				android: {
					width: undefined,
					height: undefined,
					transform: [{
						scale: [ 'cover', 'contain' ].includes( resizeMode ) ? (isSmallDevice ? scale : ( scale / 2 )) : scale,
					}]
				},
				web: {
					width: '100%',
					height: '100%',
					transform: [{
						scale: [ 'cover', 'contain' ].includes( resizeMode ) ? (isSmallDevice ? scale : ( scale / 2 )) : scale,
					}]
				}
			}),
		},
		iconImageStyle
	]
	
	return (
		<View
			style={ containerStyles }>
			
			{ linearGradientColours !== null && (
				<LinearGradient
					colors={ linearGradientColours }
					style={ [ IconBackgroundStyles.gradientOverlay, linearGradientStyle ] }
				/>
			)}
			
			<ImageBackground
				key={ HelperString.hash('icon-background', image ) }
				source={ image }
				imageStyle={ imageStyle }
				style={ imageBackgroundStyle }>
				
				{ children }
			</ImageBackground>
		</View>
	);
}

export default React.memo( IconBackground, isEqual );

